import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "background-gradient" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "feedback-message"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", null, "No results found", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 💩 ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackSwipe = _resolveComponent("BackSwipe")!
  const _component_Header = _resolveComponent("Header")!
  const _component_Searchbar = _resolveComponent("Searchbar")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_FriendCell = _resolveComponent("FriendCell")!
  const _component_CellGroup = _resolveComponent("CellGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BackSwipe),
    _createVNode(_component_Header, { title: "Add friends" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Searchbar, {
        modelValue: _ctx.searchQuery,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
        placeholder: "Search by username"
      }, null, 8, ["modelValue"]),
      (_ctx.filteredUsers.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_CellGroup, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsers, (user) => {
                  return (_openBlock(), _createBlock(_component_FriendCell, {
                    key: user.userId,
                    friend: user,
                    shouldDisplayUsername: true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_icon, {
                        name: require('@/assets/icons/user-plus.svg'),
                        size: "24",
                        onClick: () => _ctx.addFriend(user)
                      }, null, 8, ["name", "onClick"])
                    ]),
                    _: 2
                  }, 1032, ["friend"]))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : (_ctx.searchQuery.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
          : _createCommentVNode("", true)
    ])
  ]))
}